import { subUnitDivisors, currencyFormatting } from './settingsCurrency';

// NOTE: only expose configuration that should be visible in the
// client side, don't add any server secrets in this file.
//
// To pass environment variables to the client app in the build
// script, react-scripts (and the sharetribe-scripts fork of
// react-scripts) require using the REACT_APP_ prefix to avoid
// exposing server secrets to the client side.

const appSettings = {
  env: process.env.REACT_APP_ENV,
  dev: process.env.REACT_APP_ENV === 'development',
  // Puerta de pruebas: en desarrollo el modal de cobros del asistente de
  // anuncios se salta SIEMPRE, porque dar de alta una cuenta de Stripe en cada
  // prueba es un engorro. Esto lo fuerza a salir. Solo tiene efecto en
  // desarrollo, y viene apagado. Ver EditListingWizard.handlePublishListing.
  devShowPayoutModal: process.env.REACT_APP_DEV_SHOW_PAYOUT_MODAL === 'true',
  // Puerta de pruebas: la edición de la cara jardín es solo operadores
  // (Console login-as). En desarrollo, esto la abre también a anfitriones
  // normales. Solo tiene efecto con REACT_APP_ENV=development.
  devGardenFaceEditForHosts: process.env.REACT_APP_DEV_GARDEN_FACE_EDIT_FOR_HOSTS === 'true',
  verbose: false,

  sdk: {
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
    baseUrl: process.env.REACT_APP_SHARETRIBE_SDK_BASE_URL,
    assetCdnBaseUrl: process.env.REACT_APP_SHARETRIBE_SDK_ASSET_CDN_BASE_URL,
    transitVerbose: process.env.REACT_APP_SHARETRIBE_SDK_TRANSIT_VERBOSE === 'true',
  },

  // Get currency formatting options for given currency.
  // See: https://github.com/yahoo/react-intl/wiki/API#formatnumber
  getCurrencyFormatting: currencyFormatting,
  // It's not guaranteed that currencies can be split to 100 subunits!
  subUnitDivisors,

  // Sentry DSN (Data Source Name), a client key for authenticating calls to Sentry
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,

  // If webapp is using SSL (i.e. it's behind 'https' protocol)
  usingSSL: process.env.REACT_APP_SHARETRIBE_USING_SSL === 'true',
};

export default appSettings;
